import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { JobHistory } from '../../../model/jobHistory.model';
import { JobService } from '../../../services/job.service';
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TimePipe } from '../../../pipes/time.pipe';
import { DateHistoryPipe } from '../../../pipes/date.history.pipe';

@Component({
  selector: 'app-job-history-tab',
  templateUrl: './job-history-tab.component.html',
  styleUrls: ['./job-history-tab.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatIcon,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatButton,
    TimePipe,
    DateHistoryPipe
  ]
})
export class JobHistoryTabComponent {
  @Input() jobHistory: JobHistory[] = [];
  @Input() timezone: string;
  @Input() canLoadMore: boolean;
  @Output() loadMoreItems: EventEmitter<void> = new EventEmitter();
  jobHistoryColumns = ['timeStamp', 'rego', 'owner', 'action'];

  private router = inject(Router);
  private jobService = inject(JobService);

  redirectToJob(id: number) {
    this.jobService.activeJobId = id;
    this.router.navigate([`/jobViewer/${id}`]).catch();
  }
}
